import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { includeBearerTokenInterceptor } from "keycloak-angular";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing";
import { IconsModule } from "./core/icons/icons.module";
import { SharedModule } from "./modules/shared/shared.module";
import {
  MatPaginatorIntl,
  MAT_PAGINATOR_DEFAULT_OPTIONS,
} from "@angular/material/paginator";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { customPaginator } from "./modules/shared/utilities/utils";
import { keycloakProvider } from "./keycloak.config";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    IconsModule,
    SharedModule,
  ],
  providers: [
    keycloakProvider(),
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        formFieldAppearance: "outline",
        showFirstLastButtons: true,
        pageSizeOptions: [5, 10, 15],
      },
    },
    {
      provide: MatPaginatorIntl,
      useValue: customPaginator(),
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "outline", subscriptSizing: "dynamic" },
    },
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
  ],
})
export class AppModule {}
